import Vue from 'vue'
import VueRouter from 'vue-router'
// import NQ5C from '@/views/NQ5C'
// import nq5cAW from '@/views/nq5c-AW'
// import nq5cAW2024 from '@/views/nq5c-AW2024'
import nq5cAW2025 from '@/views/nq5c-AW2025'
import terms from '@/components/aw2025/terms'
import recommend from '@/components/community/recommend'
import detail from '@/components/community/detail'
import mallList from '@/components/mall/list'
import mallDetail from '@/components/mall/detail'
import article from '@/components/community/article'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'nq5c',
  //   component: NQ5C
  // },
  // {
  //   path: '/',
  //   name: 'nq5c-aw',
  //   component: nq5cAW
  // },
  // {
  //   path: '/',
  //   name: 'nq5c-aw2024',
  //   component: nq5cAW2024
  // },
  {
    path: '/',
    name: 'nq5c-aw2025',
    component: nq5cAW2025,
    meta: { title: '起亚商城 | 起亚汽车中国官网' }
  },{
    path: '/terms',
    name: 'terms',
    component: terms
  },{
    path: '/recommend',
    name: 'recommend',
    component: recommend,
    meta: { title: '用户社区 | 起亚汽车中国官网' }
  },
  {
    path: '/detail',
    name: 'detail',
    component: detail,
    meta: { title: '用户社区 | 起亚汽车中国官网' }
  },
  {
    path: '/mallList',
    name: 'mallList',
    component: mallList,
    meta: { title: '起亚商城 | 起亚汽车中国官网' }
  },{
    path: '/mall/detail',
    name: 'mallDetail',
    component: mallDetail,
    meta: { title: '起亚商城 | 起亚汽车中国官网' }
  },{
    path: '/article',
    name: 'article',
    component: article,
    meta: { title: '用户社区 | 起亚汽车中国官网' }
  }
]

const router = new VueRouter({
  // mode: 'history', // 使用 history 模式，URL 不会有 # 号
  // base: '/communityandshop/', // 与 vue.config.js 中的 publicPath 保持一致
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 对于 recommend 路由，延迟恢复滚动位置，等待内容加载完成
    if (to.name === 'recommend' && savedPosition) {
      // 返回一个 Promise，延迟恢复滚动位置
      return new Promise((resolve) => {
        // 等待 DOM 更新和图片加载
        setTimeout(() => {
          resolve(savedPosition)
        }, 300) // 300ms 延迟，确保内容已渲染
      })
    }
    // 如果有保存的位置（比如浏览器前进/后退），则使用保存的位置
    if (savedPosition) {
      return savedPosition
    } else {
      // 否则滚动到顶部
      return { x: 0, y: 0 }
    }
  }
})

router.afterEach((to) => {
  const title = to && to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
});

export default router
